export const appType = 'main'; // 'club';
export const clubId = null; //310510386;

// export const appType = 'club'; // 'club';
// export const clubId = 310510386; //310510386;

export const MygolfServerHost = 'prdlet.mygolf2u.com';
// export const MygolfServerHost = 'clslet.mygolf2u.com';
export const MygolfUIServerHost = 'player5.mygolf2u.com';
export const MygolfSSLEnable = true;

export const environment = 'prod';
export const enableChat = false;
export const chatServer = 'betachat.mygolf2u.com';
export const chatPort = '11014';

export const filterNewsPromoByDates = false;

export const enableStayNPlayRequest = false;

export const majorAppVersion = "5.0.0";

export const MygolfPortal = 'portal.mygolf2u.com';
